import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputMui } from '../../../../../../components/input-mui/input-mui';

type SerialNumberProps = {
  serialNumber: string;
};

export const SerialNumber: React.FC<SerialNumberProps> = ({ serialNumber }) => {
  const { control } = useFormContext();
  const { t } = useTranslation('installation');
  const { t: tc } = useTranslation('common');

  return (
    <Controller
      name="serialNumber"
      control={control}
      rules={{
        required: {
          value: true,
          message: tc('isRequired'),
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <InputMui
          value={serialNumber}
          label={t('exalus.serialNumber')}
          onChange={field.onChange}
          {...(error ? { errorMessage: error.message } : {})}
        />
      )}
    />
  );
};
